module.exports = __webpack_public_path__ + "img/stor_wrapbg1.800b3a59.png";